<template>
  <div class="part mt-4">
    <div class="header_style justify-content-start">
      <h2 class="h2_style mb-0">Memory</h2>
    </div>

    <div class="part__cnt">
      <div class="d-flex flex-wrap custom-labels mt-3">
        <ul v-for="item in MemoryValue" :key="item.label" class="field d-flex ps-0 my-0">
          <li class="field-label">{{ item.label }}</li>
          <li class="field-value">{{ item.value || '-' }}</li>
        </ul>
        <ul v-for="item in memNewFieldsData" :key="item.label" class="field d-flex ps-0 my-0">
          <li class="field-label">{{ item.label }}</li>
          <li class="field-value">{{ item.value || '-' }}</li>
        </ul>
      </div>

      <div v-show="hasData(usageDataFields)" class="position-relative"> 
        <div id="pss_line" style="width: 100%; height: 400px"></div>
        <div id="pss_line_tip" class="position-absolute bg-white shadow rounded p-2" style="display: none"></div>
        <label-list ref="labelList1" :perf_second_data="perf_second_data" chartKey="pss_line_chart" />
        <chart-rect ref="chartRect1" chartKey="pss_line_chart" />
      </div>

      <div v-show="hasData(memory_detail)" style="position: relative">
        <div class="position-relative"> 
          <div
            id="memory_detail"
            style="width: 100%; height: 400px"
          ></div>
          <div id="memory_detail_tip" class="position-absolute bg-white shadow rounded p-2" style="display: none"></div>
          <label-list ref="labelList2" :perf_second_data="perf_second_data" chartKey="memory_detail_chart" />
          <chart-rect ref="chartRect2" chartKey="memory_detail_chart" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as echarts from 'echarts'
import LabelList from '../label-list.vue'
import {allChart} from '../common.js'
import ChartRect from '../rect.vue'

const useUsage = {
  data() {
    return {
      usageSeries: [
        {name: 'Memory[MB]', dataKey: 'Memory[MB]'},
        {name: 'SwapMemory[MB]', dataKey: 'SwapMemory[MB]'},
        {name: 'VirtualMemory[MB]', dataKey: 'VirtualMemory[MB]'},
        {name: 'AvailableMemory[MB]', dataKey: 'AvailableMemory[MB]'},
      ]
    }
  },

  computed: {
    usageDataFields() {
      return this.usageSeries.map(item => item.dataKey)
    }
  },

  methods: {
    getPss_lineOption() {
      return {
        title: {
          text: "Memory Usage",
          textStyle: {
            fontSize: 16,
            fontWeight: 700,
            color: "#333",
          },
        },
        dataZoom: this.chartSettings.dataZoom,
        toolbox: this.chartSettings.toolbox,
        tooltip: this.chartSettings.tooltip,
        legend: this.chartSettings.legend,
        grid: this.chartSettings.grid,
        yAxis: this.chartSettings.yAxis,
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: this.xData,
        },
        series: this.usageSeries.map(item => {
          return {
            name: item.name,
            data: this.secondData?.[item.dataKey],
            type: "line",
            showSymbol: false,
            itemStyle: this.chartSettings.itemStyle2,
          }
        })
      }
    },

    drawPieChartPSS() {
      let chartDom = document.getElementById("pss_line")
      if (!chartDom) return
      if (!allChart.pss_line_chart) {
        allChart.pss_line_chart = echarts.init(chartDom)
      }
      allChart.pss_line_chart.setOption(this.getPss_lineOption(), {notMerge: true})
    },
  }
}

const useDetail = {
  data() {
    return {
      memory_detail: [
        "NativePss[MB]",
        "Gfx[MB]",
        "GL[MB]",
        "JavaHeap[MB]",
        "Unknown[MB]",
        "DalvikHeap[MB]",
        "DalvikOther[MB]",
        "Stack[MB]",
        "Cursor[MB]",
        "Ashmem[MB]",
        "OtherDev[MB]",
        ".so_mmap[MB]",
        ".jar_mmap[MB]",
        ".apk_mmap[MB]",
        ".ttf_mmap[MB]",
        ".dex_mmap[MB]",
        "Other_mmap[MB]",
        ".oat_mmap[MB]",
        ".art_mmap[MB]",
        "EGL_mtrack[MB]",
        "Other_mtrack[MB]",
      ],
    }
  },

  methods: {
    getMemDetailOption() {
      return {
        title: {
          text: "MemoryDetail",
          textStyle: {
            fontSize: 16,
            fontWeight: 700,
            color: "#333",
          },
        },
        dataZoom: this.chartSettings.dataZoom,
        toolbox: this.chartSettings.toolbox,
        tooltip: {
          ...this.chartSettings.tooltip,
          position: function (point, params, dom, rect, size) {
            return [point[0] + 20, 0]
          },
          //extraCssText: 'max-height: 300px;overflow: scroll'
        },
        legend: this.chartSettings.legend,
        grid: this.chartSettings.grid,
        yAxis: this.chartSettings.yAxis,
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: this.xData,
        },
        series: this.memory_detail.map(item => {
          return {
            name: item,
            type: "line",
            showSymbol: false,
            data: this.secondData?.[item],
            itemStyle: this.chartSettings.itemStyle2,
          }
        }),
      }
    },

    drawPieChartMemoryDetail() {
      const chartDom = document.getElementById("memory_detail")
      if (!chartDom) return
      if (!allChart.memory_detail_chart) {
        allChart.memory_detail_chart = echarts.init(chartDom)
      }
      allChart.memory_detail_chart.setOption(this.getMemDetailOption(), {notMerge: true})
    },
  }
}

export default {
  mixins: [useUsage, useDetail],

  components: {LabelList, ChartRect},

  inject: ['injectObj', 'hasData'],

  props: {
    testInfo3: Object,
    testInfo: Object,
    memNewFieldsData: Array,
    perf_second_data: Object,
    chartSettings: Object,
  },

  data() {
    return {
      
    }
  },

  computed: {
    isAllChecked() {
      return this.injectObj.isAllChecked
    },

    MemoryValue() {
      let data = this.testInfo3

      return [
        {
          label: "Avg(Memory)[MB]",
          value: data?.['Avg(Memory)[MB]'],
        },
        {
          label: "Peak(Memory)[MB]",
          value: data?.['Peak(Memory)[MB]'],
        },
        {
          label: "Avg(SwapMemory)[MB]",
          value: data?.['Avg(SwapMemory)[MB]'],
        },
        {
          label: "Peak(SwapMemory)[MB]",
          value: data?.max_swap,
        },
        {
          label: "Avg(VirtualMemory)[MB]",
          value: data?.['Avg(VirtualMemory)[MB]'],
        },
        {
          label: "Peak(VirtualMemory)[MB]",
          value: data?.max_vss,
        },
        {
          label: "Avg(AvailableMemory)[MB]",
          value: data?.['Avg(AvailableMemory)[MB]'],
        },
        {
          label: "Peak(AvailableMemory)[MB]",
          value: data?.max_available_memory,
        },
        {
          label: "Avg(NativePss)[MB]",
          value: data?.['Avg(NativePss)[MB]'],
        },
        {
          label: "Avg(Gfx)[MB]",
          value: data?.['Avg(Gfx)[MB]'],
        },
        {
          label: "Avg(GL)[MB]",
          value: data?.['Avg(GL)[MB]'],
        },
        {
          label: "Avg(JavaHeap)[MB]",
          value: data?.['Avg(JavaHeap)[MB]'],
        },
        {
          label: "Avg(Unknown)[MB]",
          value: data?.['Avg(Unknown)[MB]'],
        },
        {
          label: "Avg(DalvikHeap)[MB]",
          value: data?.dalvik_heap,
        },
        {
          label: "Avg(DalvikOther)[MB]",
          value: data?.dalvik_other,
        },
        {
          label: "Avg(Stack)[MB]",
          value: data?.['Avg(Stack)[MB]'],
        },
        {
          label: "Avg(Cursor)[MB]",
          value: data?.['Avg(Cursor)[MB]'],
        },
        {
          label: "Avg(Ashmem)[MB]",
          value: data?.['Avg(Ashmem)[MB]'],
        },
        {
          label: "Avg(OtherDev)[MB]",
          value: data?.other_dev,
        },
        {
          label: "Avg(.so mmap)[MB]",
          value: data?.['Avg(.so mmap)[MB]'],
        },
        {
          label: "Avg(.jar mmap)[MB]",
          value: data?.['Avg(.jar mmap)[MB]'],
        },
        {
          label: "Avg(.apk mmap)[MB]",
          value: data?.['Avg(.apk mmap)[MB]'],
        },
        {
          label: "Avg(.ttf mmap)[MB]",
          value: data?.['Avg(.ttf mmap)[MB]'],
        },
        {
          label: "Avg(.dex mmap)[MB]",
          value: data?.['Avg(.dex mmap)[MB]'],
        },
        {
          label: "Avg(Other mmap)[MB]",
          value: data?.['Avg(Other mmap)[MB]'],
        },
        {
          label: "Avg(.oat mmap)[MB]",
          value: data?.['Avg(.oat mmap)[MB]'],
        },
        {
          label: "Avg(.art mmap)[MB]",
          value: data?.['Avg(.art mmap)[MB]'],
        },
        {
          label: "Avg(EGL mtrack)[MB]",
          value: data?.['Avg(EGL mtrack)[MB]'],
        },
        {
          label: "Avg(Other mtrack)[MB]",
          value: data?.['Avg(Other mtrack)[MB]'],
        },
      ]
    },

    xData() {
      return this.secondData?.timeline || []
    },

    secondData() {
      return this.perf_second_data?.['每秒数据']?.rows || {}
    },
  },

  methods: {
    async init(isMounted) {
      this.drawCharts()
      await this.$nextTick()
      this.$refs.chartRect1?.init(isMounted)
      this.$refs.chartRect2?.init(isMounted)
    },

    drawCharts() {
      this.drawPieChartPSS()
      this.drawPieChartMemoryDetail()
    }
  }
}
</script>

<style scoped>
@import "../common.css"
</style>